// ===== Retire the standalone /cart page =====
  // Per Jordan: the cart drawer should be the only cart UI on the site —
  // shoppers should see everything (items, qty, total) and go straight to
  // checkout from the drawer, never the full /cart page. Shopify's native
  // cart template can't be deleted (there's no local template file for it
  // in this theme, it's the built-in fallback that always exists at
  // /cart), so this bounces anyone who lands there back to the drawer
  // instead. Body carries class "template-cart" on that page (confirmed
  // live). Sits at the very top of the file, before anything else runs,
  // so the redirect fires as early as possible. A sessionStorage flag
  // tells the code further down (see "Auto-open drawer after /cart
  // retirement redirect") to pop the drawer open the instant the shopper
  // lands back on the homepage, so their cart is still immediately visible
  // — just in the drawer instead of the old page.
  (function(){
    if(!document.body || !document.body.classList.contains('template-cart')) return;
    try{ sessionStorage.setItem('dejunoOpenCartOnLoad', '1'); }catch(e){}
    window.location.replace('/');
  })();

  // ===== Remove vendor "scroll to top" button (site-wide) =====
  // This button (bottom-left, circular, appears once you scroll away from
  // the top) isn't in any of our own liquid/CSS/JS — grepped the whole
  // repo for every plausible name (back-to-top, scroll-to-top, totop,
  // chevron-up, etc.) and found nothing. It's coming straight from
  // bundle.js/bundle.css, the Shopify-hosted vendor framework this theme
  // is built on (same place the cart-drawer's native auto-open behavior
  // came from, fixed earlier this project) — there's no source file to
  // delete it from, so it has to be neutralized at runtime instead.
  //
  // Since the vendor markup's actual tag/class name isn't visible from
  // our own code, this identifies it by what it visibly IS rather than by
  // name: a small, roughly icon-sized, fixed-position element sitting in
  // the bottom-left corner of the viewport. That shape/position is
  // distinct from every fixed element this theme's own code creates
  // (the cart drawer and mobile nav are both full-height side panels —
  // width/height far bigger than 90px; the floating PDP color bar spans
  // the full viewport width; none of them sit bottom-left specifically),
  // so this can't accidentally hide our own UI.
  (function(){
    function isScrollTopButton(el){
      if(el === document.documentElement || el === document.body) return false;
      if(el.closest('.cart-drawer, .mobile-nav, .pdp-floating-palette, #CartDrawer')) return false;
      const cs = getComputedStyle(el);
      if(cs.position !== 'fixed') return false;
      if(cs.display === 'none') return false;
      const rect = el.getBoundingClientRect();
      if(rect.width === 0 || rect.height === 0) return false;
      if(rect.width > 90 || rect.height > 90) return false;
      const nearBottom = rect.bottom > window.innerHeight - 160;
      const nearLeft = rect.left < 160;
      return nearBottom && nearLeft;
    }
    function sweep(){
      document.querySelectorAll('body *').forEach(el=>{
        if(isScrollTopButton(el)){
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }
    sweep();
    window.addEventListener('scroll', sweep, { passive:true });
    const mo = new MutationObserver(sweep);
    mo.observe(document.body, { childList:true, subtree:true });
  })();

  // ===== Force-fix hero/promo button height =====
  // theme.css sets height:26px !important on .hero-sub .btn and
  // .campaign-content .btn, and border-radius (in the very same rule)
  // visibly takes effect while height doesn't — the only thing that beats
  // an !important stylesheet rule on one property while leaving a sibling
  // property untouched is JS setting that one property directly on the
  // element via el.style.setProperty(prop, val, 'important'). That's
  // almost certainly coming from the base theme's own vendor bundle.js,
  // which isn't part of this repo (it's a Shopify-hosted file, not a
  // local asset), so it can't be edited directly. Fighting it with the
  // same technique that fixed the cart-drawer auto-open earlier: force our
  // own inline !important height (inline !important beats any external
  // stylesheet !important, including bundle.css's), then keep re-asserting
  // it any time something else touches the element's style attribute.
  (function(){
    function forceHeight(el){
      // Bail if already correct — avoids re-triggering our own attribute
      // observer in an infinite loop every time we write the style back.
      if(el.style.getPropertyValue('height') === '26px') return;
      el.style.setProperty('height', '26px', 'important');
      el.style.setProperty('line-height', '24px', 'important');
      el.style.setProperty('padding-top', '0px', 'important');
      el.style.setProperty('padding-bottom', '0px', 'important');
    }
    const targets = document.querySelectorAll('.hero-sub .btn, .campaign-content .btn');
    if(!targets.length) return;
    targets.forEach(el=>{
      forceHeight(el);
      const observer = new MutationObserver(()=> forceHeight(el));
      observer.observe(el, { attributes:true, attributeFilter:['style'] });
    });
  })();

  // ===== Force product photos to actually fill their frame =====
  // Same root cause/fix pattern as the hero/promo button height fix right
  // above: theme.css sets object-fit:cover on the standard PDP gallery
  // (.pdp-shop-main img / .pdp-shop-thumb img) and on the feature-diagram
  // view photos (.pdp-feature-diagram-photo img), but it kept LOOKING
  // like photos were still shrunk inside a padded box even after that CSS
  // was confirmed correct with nothing else in this codebase overriding
  // it — object-fit:cover cannot mathematically produce that padding on
  // its own, so something outside this codebase has to be setting an
  // inline style directly on these <img> elements at runtime (almost
  // certainly Shopify's vendor bundle.js — it has a built-in image
  // zoom/gallery component that commonly sets its own inline
  // width/height/object-fit once it initializes). An inline style always
  // wins over any external stylesheet rule, no matter how specific ours
  // is, which is exactly why editing theme.css alone had zero visible
  // effect. Forcing our own inline !important value here beats that, the
  // same way the button-height fix above beats bundle.js there — and
  // re-asserts it any time something (including a swapped-in thumbnail
  // image, or the vendor script re-running) touches the style attribute
  // again.
  (function(){
    // Gallery-fill tiles (.pdp-lifestyle-tile-a/-f, pdp-standard-shop.liquid)
    // need aspect-ratio:1/1 forced too, not just object-fit. BUG FIXED
    // HERE: originally also force-set height:100% at the same time as
    // aspect-ratio:1/1 — those two fight each other. The tile (figure) has
    // no explicit height of its own (it's sized BY its content, i.e. by
    // this image), so "height:100%" has nothing definite to resolve
    // against and the browser can end up ignoring aspect-ratio's attempt
    // to size that axis instead, leaving the box's real shape undefined —
    // exactly the wide, non-square tiles that kept showing up. Fix: for
    // these specific tiles, never set an explicit height at all — width
    // + aspect-ratio alone is enough to fully determine a square, with no
    // percentage-height ambiguity to lose the fight against.
    function forceCover(el){
      const needsAspect = el.closest('.pdp-lifestyle-tile-a, .pdp-lifestyle-tile-f');
      if(el.style.getPropertyValue('object-fit') === 'cover' && (!needsAspect || el.style.getPropertyValue('aspect-ratio') === '1 / 1')) return;
      el.style.setProperty('object-fit', 'cover', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('display', 'block', 'important');
      if(needsAspect){
        el.style.setProperty('aspect-ratio', '1 / 1', 'important');
        el.style.removeProperty('height');
      } else {
        el.style.setProperty('height', '100%', 'important');
      }
    }
    function wire(el){
      forceCover(el);
      const observer = new MutationObserver(()=> forceCover(el));
      observer.observe(el, { attributes:true, attributeFilter:['style'] });
    }
    // NOTE: .pdp-shop-main img was deliberately removed from this list —
    // that image is now meant to use object-fit:contain with padding (see
    // theme.css) so the product photo floats with its own margin inside
    // the white frame, matching Jordan's Bagsmart reference, instead of
    // being force-cropped edge-to-edge. Force-cover here was overriding
    // that CSS change completely via inline !important with zero visible
    // error, since an inline style always wins regardless of specificity.
    const selector = '.pdp-shop-thumb img, .pdp-feature-diagram-photo img, .pdp-standard-shop .pdp-lifestyle-tile img';
    document.querySelectorAll(selector).forEach(wire);
    // Thumbnails/gallery swap in new <img> elements after clicks (and the
    // feature-diagram view photos are looped fresh per block) — watch the
    // whole document for any of these being added later and wire those up
    // too, not just the ones present at page load.
    const bodyObserver = new MutationObserver((mutations)=>{
      mutations.forEach(m=>{
        m.addedNodes && m.addedNodes.forEach(node=>{
          if(node.nodeType !== 1) return;
          if(node.matches && node.matches(selector)) wire(node);
          if(node.querySelectorAll) node.querySelectorAll(selector).forEach(wire);
        });
      });
    });
    bodyObserver.observe(document.body, { childList:true, subtree:true });
  })();

  // ===== Universal add-to-cart hook (fetch-level, catches every add-to-cart
  // on the site no matter which code actually fires it) =====
  // Fact: every add-to-cart on this site — however it's triggered — ends in
  // a real POST to /cart/add.js, since that's the only way Shopify actually
  // adds an item. Rather than depending on our own button click handlers
  // being the ones that fire (which may not always be true, e.g. if the
  // base theme's own component ends up handling a click first), this wraps
  // window.fetch itself so the luggage animation, the header count badge,
  // and the "force the drawer back closed" guard all run on every single
  // successful /cart/add.js call site-wide, regardless of origin. Must sit
  // at the very top of the file, before anything else has a chance to run
  // its own fetch calls.
  // Shared suppression deadline used by both force-close observers below
  // (this fetch-wrapper one, and suppressCartDrawerAutoOpen() further down)
  // AND by the Bag button's own click handler. BUG FIXED HERE: previously
  // each observer force-closed the drawer unconditionally for a flat 4s
  // after any add-to-cart, with no way to tell "the vendor bundle popped
  // this open on its own" apart from "the shopper just clicked Bag on
  // purpose." Clicking Bag inside that 4s window opened the drawer for an
  // instant, then the observer immediately slammed it shut again — that's
  // the "have to click multiple times" bug. Fix: suppression now checks a
  // shared deadline (window.__dejunoCartSuppressUntil) instead of just
  // "was an observer started," and the Bag click handler zeroes that
  // deadline the moment a real click happens, so a genuine user-initiated
  // open is never fought, while auto-opens from bundle.js are still caught.
  window.__dejunoCartSuppressUntil = 0;

  (function(){
    const realFetch = window.fetch.bind(window);
    window.fetch = function(input, init){
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartAdd = url.indexOf('/cart/add') !== -1;
      const promise = realFetch(input, init);
      if(isCartAdd){
        promise.then(res=>{
          if(!res || !res.ok) return;
          if(typeof window.playLuggageAddAnimation === 'function'){
            window.playLuggageAddAnimation();
          }
          realFetch('/cart.js').then(r=> r.json()).then(cart=>{
            const cartCountEl = document.getElementById('cartCount');
            if(cartCountEl){
              cartCountEl.textContent = cart.item_count;
              cartCountEl.classList.toggle('is-hidden', cart.item_count === 0);
            }
          }).catch(()=>{});
          // Refresh the drawer's own contents right now, in the background,
          // so whenever the shopper actually opens it (first click or
          // later) it already shows the item they just added instead of
          // the stale pre-add snapshot — this was the "have to refresh the
          // page to see it, drawer says keep shopping" bug. Uses Shopify's
          // section-rendering endpoint (re-fetches this exact section's
          // server-rendered HTML and swaps it in) rather than any
          // guessed-at internal API, so it works regardless of which
          // component/framework is actually rendering the drawer.
          const cartDrawerSectionEl = document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]');
          if(cartDrawerSectionEl){
            const sectionId = cartDrawerSectionEl.id.replace('shopify-section-', '');
            realFetch('/?section_id=' + encodeURIComponent(sectionId))
              .then(r => r.text())
              .then(html => {
                const temp = document.createElement('div');
                temp.innerHTML = html;
                const fresh = temp.querySelector('#' + CSS.escape(cartDrawerSectionEl.id)) || temp.firstElementChild;
                const current = document.getElementById(cartDrawerSectionEl.id);
                if(fresh && current){
                  current.replaceWith(fresh);
                }
              })
              .catch(()=>{});
          }
          const drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
          if(drawer){
            window.__dejunoCartSuppressUntil = Date.now() + 4000;
            const forceClose = ()=>{
              if(typeof drawer.hide === 'function'){
                try{ drawer.hide(true); }catch(e){}
              }
              drawer.classList.remove('is-opened');
            };
            const observer = new MutationObserver(()=>{
              if(Date.now() < window.__dejunoCartSuppressUntil && drawer.classList.contains('is-opened')){
                forceClose();
              }
            });
            observer.observe(drawer, { attributes:true, attributeFilter:['class'] });
            setTimeout(()=> observer.disconnect(), 4000);
          }
        }).catch(()=>{});
      }
      return promise;
    };
  })();

  // ===== Reveal on scroll =====
  // Moved to the very top and made dependency-free on purpose: this must
  // run even if the header/cart/nav blocks below can't find their DOM
  // elements (e.g. in a theme that kept Shopify's native header/cart
  // instead of this concept's own markup) and throw partway through.
  (function(){
    const revealEls = document.querySelectorAll('[data-reveal]');
    if(!revealEls.length) return;
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold:0.15 });
    revealEls.forEach(el=> io.observe(el));
  })();

  // ===== "You may also like" carousel nudge (mobile) =====
  // A still screenshot can't show a swipe gesture, and the small peek of
  // card 3 at rest wasn't reading as "scroll for more" on its own. This
  // gives the row a one-time, gentle scroll-and-settle-back the first
  // time it's scrolled into view, so the carousel visibly moves under
  // its own power before the shopper ever touches it — same trick used
  // on plenty of native-app carousels to teach the gesture. Bows out
  // immediately if the shopper has already started scrolling it
  // themselves.
  //
  // Pulled out into its own function (not a page-load IIFE) because this
  // grid doesn't exist in the DOM at page load at all — Shopify only
  // fills the recommendations list via the client-side fetch in
  // <product-recommendations-standard> below, so a querySelectorAll run
  // at script-load time always finds zero grids and silently no-ops.
  // Called directly with the freshly-injected grid element once that
  // fetch actually resolves.
  function pdpNudgeYouMayLikeCarousel(grid){
    if(!grid || grid.dataset.nudgeWired) return;
    grid.dataset.nudgeWired = 'true';
    if(window.matchMedia && !window.matchMedia('(max-width:900px)').matches) return;
    let userTouched = false;
    grid.addEventListener('pointerdown', ()=>{ userTouched = true; }, { once:true, passive:true });
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting) return;
        io.unobserve(entry.target);
        setTimeout(()=>{
          if(userTouched || grid.scrollLeft > 0) return;
          grid.scrollTo({ left: 70, behavior:'smooth' });
          setTimeout(()=>{
            if(userTouched) return;
            grid.scrollTo({ left: 0, behavior:'smooth' });
          }, 550);
        }, 400);
      });
    }, { threshold:0.4 });
    io.observe(grid);
  }
  window.pdpNudgeYouMayLikeCarousel = pdpNudgeYouMayLikeCarousel;

  // Fallback path: don't rely solely on catching this at the one call site
  // inside the fetch callback below — watch the whole document for
  // .pdp-you-may-like-grid showing up by ANY means (a second render path,
  // a timing order this file's own author didn't anticipate, Shopify's
  // section-rendering API injecting it some other way) and wire it up the
  // moment it exists. dataset.nudgeWired above guards against double-firing
  // if both this and the direct call site both catch the same element.
  (function(){
    const existing = document.querySelectorAll('.pdp-you-may-like-grid');
    existing.forEach(pdpNudgeYouMayLikeCarousel);
    const mo = new MutationObserver((mutations)=>{
      mutations.forEach(m=>{
        m.addedNodes.forEach(node=>{
          if(node.nodeType !== 1) return;
          if(node.classList && node.classList.contains('pdp-you-may-like-grid')){
            pdpNudgeYouMayLikeCarousel(node);
          }
          if(node.querySelectorAll){
            node.querySelectorAll('.pdp-you-may-like-grid').forEach(pdpNudgeYouMayLikeCarousel);
          }
        });
      });
    });
    mo.observe(document.documentElement, { childList:true, subtree:true });
  })();

  // ===== Header offset (accounts for Aurora's native announcement bar,
  // which is 0px tall on some page types — e.g. product pages — and ~44px
  // on others like the homepage). The header used to hardcode top:42px,
  // assuming the bar was always ~42-44px, which left a floating 42px gap
  // above the header whenever the bar rendered at 0 height. This measures
  // the bar's real height live and exposes it as --announce-h so the
  // header CSS can sit flush under it regardless of page/state. =====
  (function(){
    function syncAnnounceH(){
      const bar = document.querySelector('.announcement-bar');
      const h = bar ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announce-h', h + 'px');
    }
    syncAnnounceH();
    window.addEventListener('resize', syncAnnounceH);
    window.addEventListener('load', syncAnnounceH);
    setTimeout(syncAnnounceH, 500);
  })();

  // ===== Category tiles =====
  // Tiles now carry real hrefs (set in shop-categories.liquid), so no
  // click-interception needed here anymore.

  // ===== Header luggage bag icon — add-to-cart animation =====
  // 8-frame sequence (assets/luggage-icon-1.png..8.png): closed case →
  // lid opens → box appears beside it → box flies into the case → lid
  // closes → back to closed. Frame 1 is the idle state, already the
  // img's src by default (see header-custom.liquid). This plays frames
  // 2-8 in sequence on every successful add-to-cart, then resets to
  // frame 1 — hooked into window.themeAddToCart's success callback below
  // so it fires from every Add to Cart button on the site (PDPs,
  // collection quick-add), not just one specific button.
  //
  // Frame URLs are derived from the img's own already-Liquid-resolved
  // src (asset_url output, with Shopify's CDN host + version query
  // string already baked in) rather than hardcoded here, since this is a
  // plain .js file with no access to the {{ 'x' | asset_url }} filter —
  // swapping just the "-1" to "-2" etc. in that real URL keeps the same
  // CDN host/version params for every frame.
  (function(){
    const icon = document.getElementById('luggageCartIcon');
    if(!icon) return;
    const baseSrc = icon.getAttribute('src');
    const frameSrcs = [];
    for(let i=1; i<=8; i++){
      frameSrcs.push(baseSrc.replace('luggage-icon-1', 'luggage-icon-' + i));
    }
    // Preload every frame on page load so the first add-to-cart plays
    // smoothly instead of stalling on a network request for frame 2.
    frameSrcs.forEach(src=>{ const im = new Image(); im.src = src; });

    let playing = false;
    window.playLuggageAddAnimation = function(){
      if(playing) return; // ignore overlapping triggers (rapid double add-to-cart clicks)
      playing = true;
      let frame = 2;
      const stepMs = 160;
      const timer = setInterval(()=>{
        icon.src = frameSrcs[frame - 1];
        frame++;
        if(frame > 8){
          clearInterval(timer);
          // Hold on the final closed frame briefly before resetting back
          // to the idle frame-1 src, so the sequence doesn't feel like it
          // cuts off abruptly right as the case closes.
          setTimeout(()=>{
            icon.src = frameSrcs[0];
            playing = false;
          }, 300);
        }
      }, stepMs);
    };
  })();

  // ===== Cart (Shopify Ajax Cart API) =====
  // Real cart, backed by /cart.js, /cart/add.js, /cart/change.js — no
  // mock product/price data. Server-rendered markup in cart-drawer.liquid
  // gives the correct state on first paint; this keeps it in sync after
  // any change (this drawer, or an add-to-cart on a product page).
  // Guarded: this theme's cart drawer markup may not be present (e.g. a
  // theme using Shopify's native cart instead), so skip entirely if so
  // rather than throwing and blocking every block below it.
  const cartCountEl = document.getElementById('cartCount');
  const cartItemsEl = document.getElementById('cartItems');
  const cartSubtotalEl = document.getElementById('cartSubtotal');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartToggleEl = document.getElementById('cartToggle');
  const cartCloseEl = document.getElementById('cartClose');
  const hasCartDrawer = cartCountEl && cartItemsEl && cartSubtotalEl && cartDrawer && cartOverlay && cartToggleEl && cartCloseEl;

  function formatMoney(cents){
    const amount = (cents / 100).toFixed(2);
    const symbol = (window.themeMoneyFormat && window.themeMoneyFormat.symbol) || '$';
    return symbol + amount;
  }

  function renderCart(cartData){
    if(!hasCartDrawer) return;
    cartCountEl.textContent = cartData.item_count;
    cartCountEl.classList.toggle('is-hidden', cartData.item_count === 0);
    if(cartData.item_count === 0){
      cartItemsEl.innerHTML = '<div class="cart-empty">Your bag is empty.</div>';
    } else {
      cartItemsEl.innerHTML = cartData.items.map((item, i) => `
        <div class="cart-item">
          <img src="${item.image}" alt="${item.product_title}">
          <div class="ci-info">
            <h4>${item.product_title}</h4>
            <div class="ci-price">Qty ${item.quantity} &times; ${formatMoney(item.price)}</div>
            <button class="ci-remove" data-line="${i + 1}">Remove</button>
          </div>
        </div>
      `).join('');
      cartItemsEl.querySelectorAll('[data-line]').forEach(btn=>{
        btn.addEventListener('click', ()=> changeLine(btn.dataset.line, 0));
      });
    }
    cartSubtotalEl.textContent = formatMoney(cartData.total_price);
  }

  function fetchCart(){
    return fetch('/cart.js').then(r => r.json()).then(renderCart);
  }

  function changeLine(line, quantity){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(r => r.json())
      .then(renderCart)
      .catch(()=>{});
  }

  // Exposed globally so an "Add to Cart" button on a product page (not
  // part of this pass) can call window.themeAddToCart(variantId, qty)
  // and have it show up here immediately.
  //
  // Fixed bug: this used to unconditionally call fetchCart()/openCart(),
  // which write into #cartCount/#cartItems/#cartSubtotal and toggle
  // #cartDrawer/#cartOverlay — none of which exist on this theme (it uses
  // Shopify's native <cart-drawer> component instead, same as the header's
  // Bag button below). That threw "Cannot set properties of null" inside
  // renderCart on every single Add to Cart click, so the promise chain
  // died before ever opening anything — the item was actually added
  // server-side (that fetch succeeds), the shopper just never saw it
  // until they separately clicked the Bag icon. Now it opens the same
  // native drawer the Bag icon uses, and only touches the bespoke
  // fetchCart/openCart path if this theme actually has that markup.
  // Force-close guard: something outside this file (the base theme's own
  // <cart-drawer id="CartDrawer"> component, e.g. the Shopify editor's
  // section-select handling, or its own internal wiring) can flip the
  // drawer's "is-opened" class on its own during/after an add-to-cart,
  // independent of anything we call. Rather than depend on knowing every
  // possible trigger, this watches the drawer element for a few seconds
  // right after our own add-to-cart click and forces it back closed the
  // instant it opens, no matter what opened it.
  function suppressCartDrawerAutoOpen(ms){
    const drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if(!drawer) return;
    window.__dejunoCartSuppressUntil = Date.now() + ms;
    const forceClose = ()=>{
      if(typeof drawer.hide === 'function'){
        try{ drawer.hide(true); }catch(e){}
      }
      drawer.classList.remove('is-opened');
    };
    const observer = new MutationObserver(()=>{
      if(Date.now() < window.__dejunoCartSuppressUntil && drawer.classList.contains('is-opened')){
        forceClose();
      }
    });
    observer.observe(drawer, { attributes:true, attributeFilter:['class'] });
    setTimeout(()=> observer.disconnect(), ms);
  }

  window.themeAddToCart = function(variantId, quantity){
    suppressCartDrawerAutoOpen(4000);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(()=>{
        if(typeof window.playLuggageAddAnimation === 'function'){
          window.playLuggageAddAnimation();
        }
        // Real cause of the drawer auto-opening: this theme's actual cart
        // panel is Shopify's native <cart-drawer id="CartDrawer"> web
        // component (Dawn). That component's own .update()/renderContents()
        // method calls this.open() on itself as part of its built-in
        // behavior — there's no flag to suppress it, calling update() at
        // all pops it open. So instead of touching the native drawer here,
        // just refetch /cart.js directly and update the header's own count
        // badge — the luggage animation is the only add-to-cart feedback
        // now, and the drawer stays closed until the shopper clicks Bag.
        if(hasCartDrawer){
          return fetchCart();
        }
        return fetch('/cart.js').then(r => r.json()).then(cart=>{
          if(cartCountEl){
            cartCountEl.textContent = cart.item_count;
            cartCountEl.classList.toggle('is-hidden', cart.item_count === 0);
          }
        });
      });
  };

  function openCart(){
    fetchCart();
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
  }
  function closeCart(){ cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); }
  if(hasCartDrawer){
    cartToggleEl.addEventListener('click', openCart);
    cartCloseEl.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);
  }

  // The header's Bag button (#cartToggle) needs to open this theme's
  // actual native <cart-drawer id="CartDrawer"> web component (visible
  // in the customizer under Aside Group > Cart drawer) — this theme
  // never had the bespoke #cartDrawer/#cartOverlay markup above, so
  // hasCartDrawer is false and the button had nothing wired to it at
  // all, which is why clicking Bag did nothing.
  if(cartToggleEl){
    cartToggleEl.addEventListener('click', function(e){
      // Cancel any active auto-open suppression FIRST — a real click on
      // Bag always means "open it," even if it lands inside the 4s window
      // right after an add-to-cart. Without this line, the observers above
      // would immediately force the drawer back closed and the shopper
      // would need to click again (the exact bug this fixes).
      window.__dejunoCartSuppressUntil = 0;
      const nativeCartDrawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
      if(nativeCartDrawer && typeof nativeCartDrawer.open === 'function'){
        e.preventDefault();
        nativeCartDrawer.open();
      }
    });
  }

  // Auto-open drawer after /cart retirement redirect (see top of file) —
  // fires the same real click on the Bag button the shopper would've made
  // themselves, so it opens exactly the way it normally does (vendor's own
  // click handling), just automatically instead of waiting for a click.
  (function(){
    let openedFromRedirect = false;
    try{ openedFromRedirect = sessionStorage.getItem('dejunoOpenCartOnLoad') === '1'; }catch(e){}
    if(!openedFromRedirect) return;
    try{ sessionStorage.removeItem('dejunoOpenCartOnLoad'); }catch(e){}
    window.addEventListener('load', function(){
      setTimeout(function(){
        const toggle = document.getElementById('cartToggle');
        if(toggle) toggle.click();
      }, 300);
    });
  })();

  // ===== Announcement bar carousel =====
  // Guarded: skip if this theme doesn't have the concept's own
  // announcement-bar markup (e.g. using Shopify's native one instead).
  (function(){
    const annTrack = document.getElementById('announceTrack');
    const annNextBtn = document.getElementById('annNext');
    const annPrevBtn = document.getElementById('annPrev');
    if(!annTrack || !annNextBtn || !annPrevBtn) return;
    const annSlides = annTrack.children;
    let annIndex = 0;
    let annTimer = null;
    function annGoTo(i){
      annIndex = (i + annSlides.length) % annSlides.length;
      annTrack.style.transform = `translateX(-${annIndex * 100}%)`;
    }
    function annNext(){ annGoTo(annIndex + 1); }
    function annPrev(){ annGoTo(annIndex - 1); }
    function annStartAuto(){ annStopAuto(); annTimer = setInterval(annNext, 3800); }
    function annStopAuto(){ if(annTimer){ clearInterval(annTimer); annTimer = null; } }
    annNextBtn.addEventListener('click', ()=>{ annStopAuto(); annNext(); });
    annPrevBtn.addEventListener('click', ()=>{ annStopAuto(); annPrev(); });
    annStartAuto();
  })();

  // ===== Dynamic nav pill =====
  // Guarded: skip if this theme's header doesn't have the concept's own
  // nav markup (mainNav / navPill ids).
  (function(){
    const mainNavEl = document.getElementById('mainNav');
    const navPill = document.getElementById('navPill');
    if(!mainNavEl || !navPill) return;
    const navLinks = mainNavEl.querySelectorAll('.nav-trigger');
    navLinks.forEach(link=>{
      link.addEventListener('mouseenter', ()=>{
        const linkRect = link.getBoundingClientRect();
        const navRect = mainNavEl.getBoundingClientRect();
        navPill.style.width = linkRect.width + 'px';
        navPill.style.left = (linkRect.left - navRect.left) + 'px';
        navPill.style.opacity = '1';
      });
    });
    mainNavEl.addEventListener('mouseleave', ()=>{ navPill.style.opacity = '0'; });
  })();

  // ===== Nav dropdown (mega menu) hover bridge =====
  // Single shared panel: switching between triggers never closes and
  // reopens the box itself (no more up/down blink) — it just swaps which
  // content is active and smoothly resizes to match. The panel only
  // fades open/closed once per hover session (entering/leaving the nav).
  (function(){
    const navDropdown = document.getElementById('navDropdown');
    if(!navDropdown) return;
    const navDropdownInner = document.getElementById('navDropdownInner');
    const pairs = [];
    document.querySelectorAll('.nav-trigger[data-menu-trigger]').forEach(trigger=>{
      const content = navDropdown.querySelector('.nav-dropdown-content[data-menu="'+trigger.dataset.menuTrigger+'"]');
      if(!content) return;
      pairs.push({trigger, content});
    });
    if(!pairs.length) return;

    let activeContent = null;
    let closeTimer = null;

    function measureHeight(el){
      const prevDisplay = el.style.display;
      const prevWidth = el.style.width;
      el.style.position = 'absolute';
      el.style.visibility = 'hidden';
      el.style.display = 'block';
      el.style.width = '100%';
      const h = el.scrollHeight;
      el.style.position = '';
      el.style.visibility = '';
      el.style.display = prevDisplay;
      el.style.width = prevWidth;
      return h;
    }

    function showContent(content){
      if(content === activeContent) return;
      navDropdownInner.style.height = measureHeight(content) + 'px';
      if(activeContent){
        activeContent.classList.remove('active');
        activeContent.style.display = 'none';
      }
      content.style.display = 'block';
      void content.offsetWidth; // force reflow so the opacity transition plays
      content.classList.add('active');
      activeContent = content;
    }

    function openDropdown(content){
      if(closeTimer){ clearTimeout(closeTimer); closeTimer = null; }
      showContent(content);
      navDropdown.classList.add('open');
    }

    function scheduleClose(){
      closeTimer = setTimeout(()=>{
        navDropdown.classList.remove('open');
        navDropdownInner.style.height = '0px';
      }, 400);
    }

    pairs.forEach(({trigger, content})=>{
      trigger.addEventListener('mouseenter', ()=> openDropdown(content));
      trigger.addEventListener('mouseleave', scheduleClose);
    });
    navDropdown.addEventListener('mouseenter', ()=>{
      if(closeTimer){ clearTimeout(closeTimer); closeTimer = null; }
    });
    navDropdown.addEventListener('mouseleave', scheduleClose);

    // Category-trigger hover-swap, shared by both Bags & Backpacks
    // (data-bag-category/data-bag-list) and Luggage
    // (data-luggage-category/data-luggage-list). Hovering a category
    // swaps which product list previews next to it; each trigger is also
    // a real link to that category's full collection page, so clicking
    // navigates normally — this only manages the preview swap, it never
    // blocks the click. Each menu's list container has its own fixed
    // min-height (see theme.css) so this swap never resizes the outer
    // mega-menu panel, no matter which menu it runs in.
    function wireCategorySwap(categoryAttr, listAttr){
      const triggers = navDropdown.querySelectorAll('[' + categoryAttr + ']');
      triggers.forEach(trigger=>{
        const key = trigger.dataset[toCamel(categoryAttr)];
        const list = navDropdown.querySelector('[' + listAttr + '="' + key + '"]');
        if(!list) return;
        trigger.addEventListener('mouseenter', ()=>{
          triggers.forEach(t=> t.classList.remove('active'));
          navDropdown.querySelectorAll('[' + listAttr + ']').forEach(l=> l.classList.remove('active'));
          trigger.classList.add('active');
          list.classList.add('active');
        });
      });
    }
    function toCamel(attr){
      // 'data-bag-category' -> 'bagCategory' (matches the property name
      // the browser exposes on .dataset for that attribute).
      return attr.replace(/^data-/, '').replace(/-([a-z])/g, (_, c)=> c.toUpperCase());
    }
    wireCategorySwap('data-bag-category', 'data-bag-list');
    wireCategorySwap('data-luggage-category', 'data-luggage-list');
  })();

  // ===== Header scroll state =====
  // Guarded: skip if this theme's header doesn't use the concept's own
  // siteHeader id.
  (function(){
    const header = document.getElementById('siteHeader');
    if(!header) return;
    window.addEventListener('scroll', ()=>{
      header.classList.toggle('scrolled', window.scrollY > 60);
    });
  })();

  // ===== Mobile nav =====
  // Guarded: skip if this theme doesn't have the concept's own mobile
  // nav drawer markup.
  const mobileNav = document.getElementById('mobileNav');
  const burgerBtnEl = document.getElementById('burgerBtn');
  const drawerCloseEl = document.getElementById('drawerClose');
  if(mobileNav && burgerBtnEl && drawerCloseEl){
    burgerBtnEl.addEventListener('click', ()=> mobileNav.classList.add('open'));
    drawerCloseEl.addEventListener('click', ()=> mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a=> a.addEventListener('click', ()=> mobileNav.classList.remove('open')));
  }

  // ===== Mobile nav drill-down =====
  // All screens sit side by side in a flex track; opening a section
  // slides the whole track left by (screenIndex * 100%) so only that
  // screen's short link list is ever visible at once, with a Back
  // button to return to the root screen. Resets to root whenever the
  // drawer is (re)opened so it never reopens mid-drill.
  (function(){
    if(!mobileNav) return;
    const track = document.getElementById('mnavTrack');
    if(!track) return;
    const screens = Array.from(track.querySelectorAll('[data-mnav-screen]'));
    function goTo(key){
      const idx = screens.findIndex(s => s.dataset.mnavScreen === key);
      if(idx === -1) return;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      // Drives which of the promo tiles (siblings of the sliding track,
      // see mobile-nav.liquid) is visible — CSS matches this against each
      // tile's data-mnav-promo. Kept outside the track/screens entirely so
      // the promo's edge-to-edge negative-margin bleed can never reveal a
      // neighboring screen the way it did when it lived inside one.
      mobileNav.dataset.mnavActive = key;
    }
    mobileNav.querySelectorAll('[data-mnav-drill]').forEach(btn=>{
      btn.addEventListener('click', ()=> goTo(btn.dataset.mnavDrill));
    });
    mobileNav.querySelectorAll('[data-mnav-back]').forEach(btn=>{
      btn.addEventListener('click', ()=> goTo('root'));
    });
    if(burgerBtnEl) burgerBtnEl.addEventListener('click', ()=> goTo('root'));
  })();

  // ===== Newsletter background video: seamless loop =====
  // The native `loop` attribute causes a visible flash of black in most
  // browsers right at the restart (the decoder briefly flushes at
  // end-of-stream before looping). Looping manually via timeupdate —
  // jumping back to 0 slightly *before* the true end — avoids that
  // end-of-stream handling entirely, so there's no gap to see.
  const newsletterVideo = document.getElementById('newsletterBgVideo');
  if(newsletterVideo){
    let newsletterLooping = false;
    newsletterVideo.addEventListener('timeupdate', ()=>{
      if(!newsletterLooping && newsletterVideo.duration && newsletterVideo.currentTime > newsletterVideo.duration - 0.2){
        newsletterLooping = true;
        newsletterVideo.currentTime = 0;
        newsletterVideo.play().catch(()=>{});
      }
    });
    // Reset the guard once playback is safely away from the loop point,
    // and fall back to a hard restart if the browser ever pauses on 'ended'
    // (e.g. the timeupdate window got skipped).
    newsletterVideo.addEventListener('playing', ()=>{
      if(newsletterVideo.currentTime < newsletterVideo.duration - 0.5){
        newsletterLooping = false;
      }
    });
    newsletterVideo.addEventListener('ended', ()=>{
      newsletterVideo.currentTime = 0;
      newsletterVideo.play().catch(()=>{});
    });
  }

  // Finder section is now just static links (see HTML) — no quiz JS needed.

  // ===== Journal category filters =====
  // No-ops safely when there are no articles/filter buttons yet (empty
  // journal-filters querySelectorAll just returns an empty NodeList).
  (function(){
    const filterBtns = document.querySelectorAll('.journal-filter-btn');
    const cards = document.querySelectorAll('.journal-card');
    filterBtns.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        filterBtns.forEach(b=> b.classList.remove('active'));
        btn.classList.add('active');
        const filter = btn.dataset.filter;
        cards.forEach(card=>{
          const show = filter === 'all' || card.dataset.category === filter;
          card.classList.toggle('is-hidden', !show);
        });
      });
    });
  })();

  // ===== Collection grid: color swatch preview =====
  // Clicking a swatch swaps the card's primary image (the hover-swap 2nd
  // image is untouched — it's fixed per merchant preference, not tied to
  // color) and updates the card's product/title links to carry
  // ?variant=<id>, so clicking through to the PDP lands on the color the
  // shopper just picked (same idea as the ?variant= handling on the
  // Weekender/Eminence PDPs themselves).
  //
  // selectCollSwatch() is shared with the filters panel below — when a
  // color filter (e.g. "Black") is checked, every matching card should
  // not just stay visible, it should switch to show its Black variant.
  function selectCollSwatch(card, swatch){
    if(!card || !swatch) return;
    const primaryImg = card.querySelector('.coll-card-img-primary');
    const links = card.querySelectorAll('.coll-card-link');
    const swatches = card.querySelectorAll('.coll-card-swatch');
    const colorNameEl = card.querySelector('[data-color-name]');
    const quickAddBtn = card.querySelector('[data-quick-add]');

    swatches.forEach(s=> s.classList.remove('active'));
    swatch.classList.add('active');
    if(primaryImg && swatch.dataset.image){
      primaryImg.src = swatch.dataset.image;
    }
    if(colorNameEl && swatch.dataset.color){
      colorNameEl.textContent = swatch.dataset.color;
    }
    const variantId = swatch.dataset.variantId;
    if(!variantId) return;
    links.forEach(a=>{
      if(!a.dataset.baseHref){
        a.dataset.baseHref = a.getAttribute('href').split('?')[0];
      }
      a.href = a.dataset.baseHref + '?variant=' + variantId;
    });
    // Quick-add always needs to point at whichever variant is currently
    // shown on the card, not just the product's original default variant —
    // otherwise picking a color then hitting quick-add would silently add
    // the wrong color to the cart. Label text follows the same switch, so
    // an out-of-stock color reads "Sold Out" instead of a misleadingly
    // clickable-looking "Add to Cart".
    if(quickAddBtn){
      quickAddBtn.dataset.variantId = variantId;
      const available = swatch.dataset.available !== 'false';
      quickAddBtn.disabled = !available;
      const label = quickAddBtn.querySelector('[data-qa-label]');
      if(label && !quickAddBtn.classList.contains('added')){
        label.textContent = available ? 'Add to Bag' : 'Sold Out';
      }
    }
  }

  // Pulled out of the old page-load-only IIFEs into a reusable function so
  // it can be re-run after markup is injected later (the "You may also
  // like" section on product pages loads its .coll-grid asynchronously via
  // fetch — see pdp-you-may-like.liquid / product-recommendations-standard
  // below — so its swatch/quick-add listeners can't be wired at initial
  // page-load time like the collection page's grid can).
  function pdpWireCollGrid(grid){
    if(!grid) return;
    grid.querySelectorAll('.coll-card').forEach(card=>{
      card.querySelectorAll('.coll-card-swatch').forEach(swatch=>{
        swatch.addEventListener('click', ()=> selectCollSwatch(card, swatch));
      });
    });

    // ===== Collection grid: quick-add =====
    // Adds the currently-displayed variant straight to the cart from the
    // grid, no product-page visit required. Uses the same window.themeAddToCart
    // helper the PDPs use (see the Cart block above) so it opens/refreshes
    // the same native cart drawer either way.
    grid.querySelectorAll('[data-quick-add]').forEach(btn=>{
      const label = btn.querySelector('[data-qa-label]');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if(btn.disabled) return;
        const variantId = btn.dataset.variantId;
        if(!variantId || typeof window.themeAddToCart !== 'function') return;

        const restLabel = label ? label.textContent : 'Add to Bag';
        btn.disabled = true;
        btn.classList.add('loading');
        if(label) label.textContent = 'Adding...';
        // Guaranteed re-enable via .finally() — previously this button only
        // reset itself inside .then()/.catch(), so if anything unexpected
        // happened in that promise chain it could stay permanently
        // disabled for that one product's quick-add button specifically
        // (a different product's button is a separate DOM element, so it
        // kept working fine — exactly matching "can't add this product
        // again, but a different product works").
        let addSucceeded = false;
        window.themeAddToCart(variantId, 1)
          .then(()=>{ addSucceeded = true; })
          .catch(()=>{})
          .finally(()=>{
            btn.classList.remove('loading');
            btn.disabled = false;
            if(addSucceeded){
              btn.classList.add('added');
              if(label) label.textContent = 'Added';
              setTimeout(()=>{
                btn.classList.remove('added');
                if(label) label.textContent = restLabel;
              }, 1400);
            } else if(label){
              label.textContent = restLabel;
            }
          });
      });
    });
  }
  window.pdpWireCollGrid = pdpWireCollGrid;

  document.querySelectorAll('.coll-grid').forEach(pdpWireCollGrid);

  // ===== "You may also like" (product page) — recommendations fetch =====
  // Shopify only populates the `recommendations` Liquid object when a
  // section is requested through routes.product_recommendations_url — a
  // plain page load always renders this section with an empty
  // recommendations list. Dawn's own product-recommendations section
  // solves this the same way: wrap the section content in a custom
  // element carrying the fetch URL, fetch it once the element is on the
  // page, and swap the returned markup straight in. Re-run
  // pdpWireCollGrid() on the freshly-injected .coll-grid afterward since
  // it wasn't in the DOM yet when the page first loaded.
  if(!customElements.get('product-recommendations-standard')){
    customElements.define('product-recommendations-standard', class extends HTMLElement{
      connectedCallback(){
        const url = this.dataset.url;
        if(!url) return;
        fetch(url)
          .then(r=> r.text())
          .then(html=>{
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newEl = doc.querySelector('product-recommendations-standard');
            if(newEl && newEl.querySelector('.coll-grid')){
              this.innerHTML = newEl.innerHTML;
              pdpWireCollGrid(this.querySelector('.coll-grid'));
              pdpNudgeYouMayLikeCarousel(this.querySelector('.pdp-you-may-like-grid'));
            } else {
              this.remove();
            }
          })
          .catch(()=>{ this.remove(); });
      }
    });
  }

  // ===== Collection grid: color wheel slices =====
  // Shapes each color-filter wedge with an exact clip-path polygon, using
  // real trigonometry (Liquid has none, and the CSS-only rotate+skewY pie
  // trick tried before this rendered as overlapping parallelograms instead
  // of clean wedges — see the long comment in collection-main.liquid).
  // Each slice's data-start/data-end (degrees, 0 = 12 o'clock, clockwise —
  // matching the conic-gradient's own "from 0deg" convention) come straight
  // from the same Liquid math that built the gradient, so the clip-path
  // computed here lines up with the visible color underneath it exactly.
  function buildWheelSlicePolygon(cx, cy, outerR, innerR, startDeg, endDeg){
    const steps = 8; // points along each arc — plenty smooth at this size
    const toXY = (deg, r) => {
      const rad = (deg * Math.PI) / 180;
      return [cx + r * Math.sin(rad), cy - r * Math.cos(rad)];
    };
    const points = [];
    for(let i = 0; i <= steps; i++){
      const deg = startDeg + ((endDeg - startDeg) * i) / steps;
      points.push(toXY(deg, outerR));
    }
    for(let i = steps; i >= 0; i--){
      const deg = startDeg + ((endDeg - startDeg) * i) / steps;
      points.push(toXY(deg, innerR));
    }
    return 'polygon(' + points.map(p => p[0].toFixed(2) + 'px ' + p[1].toFixed(2) + 'px').join(', ') + ')';
  }

  function layoutColorWheels(){
    document.querySelectorAll('[data-color-wheel]').forEach(wheel=>{
      const size = wheel.getBoundingClientRect().width;
      if(!size) return;
      const cx = size / 2;
      const cy = size / 2;
      const outerR = size / 2;
      // 0.53 matches the ring's mask stop (radial-gradient(circle
      // closest-side, transparent 52%, #000 53%)) — "closest-side" makes
      // that percentage relative to size/2 (the box's own radius), same
      // basis used here, so this actually lines up with the visible hole.
      const innerR = (size / 2) * 0.53;
      wheel.querySelectorAll('[data-wheel-slice]').forEach(slice=>{
        const startDeg = parseFloat(slice.dataset.start);
        const endDeg = parseFloat(slice.dataset.end);
        if(isNaN(startDeg) || isNaN(endDeg)) return;
        const polygon = buildWheelSlicePolygon(cx, cy, outerR, innerR, startDeg, endDeg);
        slice.style.clipPath = polygon;
        slice.style.webkitClipPath = polygon;
      });
      // The highlight is a sibling of its slice, not a child — see the
      // long comment on .coll-filters-wheel-slice-highlight in theme.css
      // for why. It gets the exact same wedge polygon as its paired slice
      // (no padding/widening here) — an earlier version tried to pad this
      // outward to fake the "pops past the edge" look, but padding two
      // independent arcs' worth of points can self-intersect into a
      // degenerate polygon, which is what produced the stray straight
      // line jutting out past the ring. Growth now comes from
      // transform:scale() in theme.css instead, which scales this
      // already-correctly-shaped clipped wedge as a whole — no separate
      // enlarged geometry needed, and nothing to self-intersect.
      wheel.querySelectorAll('[data-wheel-highlight]').forEach(hi=>{
        const startDeg = parseFloat(hi.dataset.start);
        const endDeg = parseFloat(hi.dataset.end);
        if(isNaN(startDeg) || isNaN(endDeg)) return;
        const polygon = buildWheelSlicePolygon(cx, cy, outerR, innerR, startDeg, endDeg);
        hi.style.clipPath = polygon;
        hi.style.webkitClipPath = polygon;
      });
    });
  }

  function syncWheelHighlights(wheel){
    wheel.querySelectorAll('[data-wheel-slice]').forEach(slice=>{
      const input = slice.querySelector('.coll-filters-wheel-slice-input');
      const idx = slice.dataset.sliceIndex;
      const hi = wheel.querySelector('[data-wheel-highlight][data-slice-index="' + idx + '"]');
      if(!input || !hi) return;
      hi.classList.toggle('is-selected', input.checked);
    });
  }

  if(document.querySelector('[data-color-wheel]')){
    layoutColorWheels();
    window.addEventListener('resize', layoutColorWheels);
    // The filters panel starts hidden (display:none via [hidden]) — a
    // clip-path computed while a container is hidden can end up sized off
    // a 0-width box. Recompute right when the panel opens, once, to catch
    // that case (see toggleBtn click handler below, which calls this).
    window.themeLayoutColorWheels = layoutColorWheels;

    // input:checked + .highlight (a pure-CSS sibling selector) no longer
    // works now that the highlight isn't adjacent to its checkbox in the
    // DOM (it's a sibling of the *label*, one level up) — so the
    // "selected" look is driven from JS instead, toggling .is-selected on
    // the paired highlight whenever a color checkbox's state changes.
    document.querySelectorAll('[data-color-wheel]').forEach(wheel=>{
      syncWheelHighlights(wheel);
      wheel.addEventListener('change', (e)=>{
        if(e.target && e.target.classList.contains('coll-filters-wheel-slice-input')){
          syncWheelHighlights(wheel);
        }
      });
    });
    window.themeSyncWheelHighlights = function(){
      document.querySelectorAll('[data-color-wheel]').forEach(syncWheelHighlights);
    };
  }

  // ===== Collection grid: filters panel =====
  // Client-side filtering/sorting over whatever's currently rendered in
  // .coll-grid. This only works correctly if every product in the
  // collection is on the page at once (products_per_page bumped to 48 in
  // the section schema) — filtering can't reach into a second pagination
  // page it hasn't rendered.
  (function(){
    const wrap = document.querySelector('[data-coll-filters]');
    const grid = document.querySelector('[data-coll-grid]');
    if(!wrap || !grid) return;

    // The filters panel now lives as a sidebar next to .coll-main (a real
    // layout column, not a floating dropdown), so it's no longer a
    // descendant of [data-coll-filters] — it's found from the document
    // instead. The panel's own click handler below still stops
    // propagation, so the "click outside closes it" listener further down
    // (which only checks wrap.contains) is unaffected by this move.
    const toggleBtn = wrap.querySelector('[data-filters-toggle]');
    const panel = document.querySelector('[data-filters-panel]');
    const clearBtn = panel ? panel.querySelector('[data-filters-clear]') : null;
    if(!panel || !toggleBtn) return;
    const countEl = document.querySelector('[data-coll-count]');
    const noMatchesEl = document.querySelector('[data-coll-no-matches]');
    const cards = Array.from(grid.querySelectorAll('.coll-card'));
    const originalOrder = cards.slice();

    // Open/closed is now driven by an .is-open class instead of the
    // [hidden] attribute, so theme.css can transition width/max-height
    // and opacity smoothly instead of the panel just snapping in and out
    // of existence.
    function isOpen(){ return panel.classList.contains('is-open'); }
    function closePanel(){
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.classList.remove('active');
    }
    function openPanel(){
      // Anchors the mobile panel's top edge (see .coll-filters-panel's
      // mobile rules in theme.css, which read this custom property) to
      // just below the Filters button's real on-screen position — the
      // button sits at a different height on every collection page
      // depending on how long the title/subtitle run. The panel itself is
      // pinned to the right edge of the screen in CSS (right:0), so only
      // the vertical position needs computing here. Harmless on desktop:
      // the panel isn't position:fixed there, so this has no effect.
      const btnRect = toggleBtn.getBoundingClientRect();
      panel.style.setProperty('--coll-filters-top', (btnRect.bottom + 8) + 'px');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      toggleBtn.classList.add('active');
    }
    // The color wheel's clip-path math needs the wheel's real rendered
    // size, which is still 0 the instant .is-open is added — the panel
    // hasn't actually finished expanding yet, it's just started the CSS
    // transition. Recomputing here, on transitionend, instead of
    // immediately after openPanel() guarantees the wheel measures its
    // real final size. propertyName is checked since width (desktop) and
    // max-height (mobile, see the 900px breakpoint in theme.css) fire
    // separate transitionend events depending on layout.
    panel.addEventListener('transitionend', (e)=>{
      if(!isOpen()) return;
      if(e.propertyName === 'width' || e.propertyName === 'max-height'){
        if(typeof window.themeLayoutColorWheels === 'function'){
          window.themeLayoutColorWheels();
        }
      }
    });
    toggleBtn.addEventListener('click', (e)=>{
      e.stopPropagation();
      if(isOpen()){ closePanel(); } else { openPanel(); }
    });
    document.addEventListener('click', (e)=>{
      if(isOpen() && !wrap.contains(e.target) && !panel.contains(e.target)) closePanel();
    });
    panel.addEventListener('click', (e)=> e.stopPropagation());

    function getChecked(type){
      return Array.from(panel.querySelectorAll('[data-filter-type="' + type + '"]:checked')).map(i=> i.value);
    }

    function applyFilters(){
      const colors = getChecked('color');
      const sizes = getChecked('size');
      const types = getChecked('type');
      const wantNew = panel.querySelector('[data-filter-type="new"]:checked') ? true : false;

      let visibleCount = 0;
      cards.forEach(card=>{
        const cardColors = (card.dataset.colors || '').split('|').filter(Boolean);
        const cardSizes = (card.dataset.sizes || '').split('|').filter(Boolean);
        const cardType = card.dataset.type || '';
        const cardIsNew = card.dataset.new === 'true';

        let visible = true;
        if(colors.length && !colors.some(c=> cardColors.includes(c))) visible = false;
        if(visible && sizes.length && !sizes.some(s=> cardSizes.includes(s))) visible = false;
        if(visible && types.length && !types.includes(cardType)) visible = false;
        if(visible && wantNew && !cardIsNew) visible = false;

        // A color filter shouldn't just hide non-matching products — a
        // matching card should actually switch to show the variant in
        // that color (e.g. checking "Black" should flip a navy/black
        // two-tone bag over to its black swatch, not just leave it navy).
        if(visible && colors.length){
          const matchSwatch = Array.from(card.querySelectorAll('.coll-card-swatch')).find(sw=>{
            const fams = (sw.dataset.families || '').split('|').filter(Boolean);
            return colors.some(c=> fams.includes(c));
          });
          if(matchSwatch && !matchSwatch.classList.contains('active')){
            selectCollSwatch(card, matchSwatch);
          }
        }

        card.style.display = visible ? '' : 'none';
        if(visible) visibleCount++;
      });

      if(noMatchesEl) noMatchesEl.hidden = visibleCount !== 0;
      if(countEl) countEl.textContent = visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');

      applySort();
    }

    function applySort(){
      const sortInput = panel.querySelector('input[name="collSort"]:checked');
      const sortValue = sortInput ? sortInput.value : 'relevance';
      let sorted;
      if(sortValue === 'price-asc'){
        sorted = cards.slice().sort((a,b)=> (parseFloat(a.dataset.price)||0) - (parseFloat(b.dataset.price)||0));
      } else if(sortValue === 'price-desc'){
        sorted = cards.slice().sort((a,b)=> (parseFloat(b.dataset.price)||0) - (parseFloat(a.dataset.price)||0));
      } else {
        sorted = originalOrder;
      }
      sorted.forEach(card=> grid.appendChild(card));
    }

    // Sort (radio) is a single, mutually-exclusive pick, so closing the
    // panel right after choosing it feels natural. Checkboxes (Type,
    // Availability, and — critically — the color wheel) are meant for
    // picking several at once; auto-closing on every single click made it
    // impossible to select more than one, and was also the actual reason
    // the color wheel's selected-state highlight seemed to never show up:
    // the whole panel (wheel included) was hidden again the instant a
    // wedge was clicked, before there was ever a frame to see it render.
    panel.querySelectorAll('input[type="radio"]').forEach(input=>{
      input.addEventListener('change', ()=>{
        applyFilters();
        closePanel();
      });
    });
    panel.querySelectorAll('input[type="checkbox"]').forEach(input=>{
      input.addEventListener('change', ()=>{
        applyFilters();
      });
    });

    clearBtn.addEventListener('click', ()=>{
      panel.querySelectorAll('input[type="checkbox"]').forEach(i=> i.checked = false);
      const relevance = panel.querySelector('input[name="collSort"][value="relevance"]');
      if(relevance) relevance.checked = true;
      // Setting .checked directly (not via a real click) doesn't fire a
      // change event, so the color wheel's .is-selected highlights would
      // otherwise be left showing stale selections after Clear all.
      if(window.themeSyncWheelHighlights) window.themeSyncWheelHighlights();
      applyFilters();
    });
  })();